import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupersetDashboardComponent } from './superset-dashboard.component';
import { SupersetComponent } from './superset/superset.component';
import { DashMenuComponent } from './dash-menu/dash-menu.component';

const routes: Routes = [
  {path: '', component: SupersetDashboardComponent, children: [
    {path:'', component: DashMenuComponent},  // Default route - component handles redirect
    {path:':name', component: DashMenuComponent},  // Default route - component handles redirect
    {path:':name/:id', component: SupersetComponent},
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupersetDashboardRoutingModule { }
